var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconEnter48Line = function SvgIconEnter48Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.8 11v15.38H17.19l6.23-6-2.36-2.45-8.37 8.05a2.897 2.897 0 0 0 0 4.18l8.37 8.06 2.36-2.45-6.23-6H33.3c1.6 0 2.9-1.3 2.9-2.9V11h-3.4Z",
    fill: "current"
  })));
};
export default SvgIconEnter48Line;